<template>
    <section>
        <div v-if="document.type === 'card'" class="container">
            <prismic-image
                :img="document.data.image"
                w="300"
                h="188"
                :lazy="false"
            />
        </div>

        <div class="container">
            <div class="section-width-md">
                <h1 v-html="$translate('redirect_text', 'Häng kvar, du skickas vidare till {title}')
                    .replace('{title}', `<span>${documentTitle}</span>`)"
                />
            </div>
        </div>
    </section>
</template>

<script>
import getDocument from '@/plugins/get-document.js';
import { escapeHtml } from '@swegaming-ab/nuxtjs-helpers';
export default {
    async middleware({ store, $prismic, route }) {
        await store.dispatch('fetchStates', { $prismic, route });
    },
    async asyncData({$prismic, route, error}) {
        try {
            return await getDocument($prismic, route.path, error, 'out');
        }
        catch (e) {
            error({statusCode: 404, message: 'Not found'});
        }
    },
    head() {
        return {
            title: 'Redirecting',
            meta: [
                { name: 'robots', content: 'noindex, nofollow' }
            ]
        };
    },
    computed: {
        documentTitle() {
            return escapeHtml(this.document.data.title);
        } 
    },
    methods: {
        fromDeniedList() {
            const query = this.$route.query;
            return Object.keys(query).length > 0 && 
                query.denied_list && 
                query.denied_list === 'true';
        },
        getOutLinkUrl() {
            let outLinkUrl = this.document.data.out_link_url;
            
            if (this.fromDeniedList()) {
                const queryParams = new URLSearchParams(this.$route.query);
                const newTrackingParams = new URLSearchParams();

                newTrackingParams.set('denied_list_source_id', process.env.CORE_SOURCE_ID);
                if (queryParams.has('application_offer_id')) {
                    newTrackingParams.set('denied_list_application_broker_offer_id', queryParams.get('application_offer_id'));
                }
                if (queryParams.has('broker_link')) {
                    newTrackingParams.set('denied_list_broker_link', queryParams.get('broker_link'));
                }

                const origins = [
                    'sgclid', 'sgid', 'gclid', 'msclkid',
                ];
                for (const origin of origins) {
                    if (queryParams.has(origin)) {
                        newTrackingParams.set(origin, queryParams.get(origin));
                        newTrackingParams.set('denied_list_tracking_key', origin);
                        newTrackingParams.set('denied_list_tracking_value', queryParams.get(origin));
                    }
                }

                const separator = outLinkUrl.includes('?') ? '&' : '?';
                return outLinkUrl + separator + newTrackingParams.toString();
            }

            return this.$tracking.addTrackingParameters(outLinkUrl);
        }
    },
    mounted() {
        setTimeout(() => {
            window.location.assign(this.getOutLinkUrl());
        }, 250);
    }
};
</script>

<style lang="scss" scoped>
    section::v-deep {
        background: $white;
        padding: 0;
        height: 100vh;
        @include grid(1,0);
        @include flex(start,stretch);


        .container {
            width: 100%;
            @include flex;
            @include spacing(padding,6);
            text-align: center;

            &:first-child {
                background: $graybg;

                img {
                    height: auto;
                }
            }

            span {
                color: $purple;
            }
        }
    }
</style>
